import { Optional, Record, String, Unknown } from 'runtypes'

export const DataTablesTypeGuard = Record({
  uuid_objectclass: String,
  uuid_layout_classification: Optional(String),
  uuid_filteraction: Optional(String),
  styleMap: Optional(Unknown)
})
